import { Language } from "@edp-models/language.model";

export interface ILanguageState {
    languages: Language[];
}

export const initialLanguageState: ILanguageState = {
    languages: [],
};
